// AI File Readiness (BETA) — shared visual primitives: colour tokens, compact badge for pipeline cards, BETA pill.
import React from 'react';
import { Sparkles } from 'lucide-react';

export const TONE = {
  green:  { text: 'text-emerald-700', bg: 'bg-emerald-50', ring: 'ring-emerald-200', dot: 'bg-emerald-500', bar: 'bg-emerald-500', hex: '#10b981' },
  orange: { text: 'text-amber-700',   bg: 'bg-amber-50',   ring: 'ring-amber-200',   dot: 'bg-amber-500',   bar: 'bg-amber-500',   hex: '#f59e0b' },
  red:    { text: 'text-rose-700',    bg: 'bg-rose-50',    ring: 'ring-rose-200',    dot: 'bg-rose-500',    bar: 'bg-rose-500',    hex: '#e11d48' },
  slate:  { text: 'text-slate-600',   bg: 'bg-slate-100',  ring: 'ring-slate-200',   dot: 'bg-slate-400',   bar: 'bg-slate-400',   hex: '#94a3b8' },
};
export const toneOf = (r) => TONE[r?.colour] || TONE.slate;

export const AIBetaPill = ({ size = 'sm', className = '', testId = 'ai-readiness-beta-pill' }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full bg-[#15133A] text-white font-black uppercase tracking-[0.14em] align-middle select-none ${size === 'xs' ? 'text-[8.5px] px-1.5 py-[2px]' : 'text-[9.5px] px-2 py-[3px]'} ${className}`}>
    <Sparkles className="w-2.5 h-2.5 text-emerald-300" /> AI Readiness <span className="text-emerald-300">BETA</span>
  </span>
);

export function ReadinessBadge({ readiness, testId, compact = false }) {
  if (!readiness?.beta) return null;
  const t = toneOf(readiness);
  const sub = readiness.status === 'client_action_required' && readiness.client_outstanding
    ? `${readiness.client_outstanding} client item${readiness.client_outstanding === 1 ? '' : 's'} missing`
    : readiness.label;
  return (
    <span data-testid={testId} title={`AI File Readiness · ${readiness.pct}% · ${readiness.label} — ${readiness.headline}`}
      className={`inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-[11px] font-bold ring-1 whitespace-nowrap ${t.bg} ${t.text} ${t.ring}`}>
      <span className={`h-2 w-2 rounded-full ${t.dot}`} />
      <span className="tabular-nums">{readiness.pct}% Ready</span>
      {!compact && <span className="font-semibold opacity-80">· {sub}</span>}
    </span>
  );
}

export function ScoreRing({ pct, colour, size = 84 }) {
  const r = (size - 10) / 2, c = 2 * Math.PI * r;
  const t = TONE[colour] || TONE.slate;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="shrink-0" aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} stroke="#E8EAF1" strokeWidth="8" fill="none" />
      <circle cx={size / 2} cy={size / 2} r={r} stroke={t.hex} strokeWidth="8" fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - Math.max(0, Math.min(100, pct)) / 100)} transform={`rotate(-90 ${size / 2} ${size / 2})`} style={{ transition: 'stroke-dashoffset .6s ease' }} />
      <text x="50%" y="52%" dominantBaseline="middle" textAnchor="middle" className="fill-slate-900" style={{ fontSize: size * 0.27, fontWeight: 900, fontFamily: 'Outfit, sans-serif' }}>{pct}%</text>
    </svg>
  );
}
